// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TranslationOutlinedSvg from "@ant-design/icons-svg/es/asn/TranslationOutlined";
import AntdIcon from '../components/AntdIcon';

var TranslationOutlined = function TranslationOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TranslationOutlinedSvg
  }));
};

TranslationOutlined.displayName = 'TranslationOutlined';
export default React.forwardRef(TranslationOutlined);